import { GlobalController } from 'src/shared/global/GlobalController'
import BillingOrderAction from './BillingOrderAction'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'billingOrderAction',
    component: BillingOrderAction,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
